import { render } from "./BuyerOrder.vue?vue&type=template&id=3cf87198&scoped=true"
import script from "./BuyerOrder.vue?vue&type=script&lang=js"
export * from "./BuyerOrder.vue?vue&type=script&lang=js"

import "./BuyerOrder.vue?vue&type=style&index=0&id=3cf87198&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf87198"]])

export default __exports__